import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import {
  ProjectStateAsString,
  ProjectStatus,
} from 'controllers/Project/ProjectStateMachine'
import { ErrorCountBadge } from './ErrorCountBadge'

import { CSSProperties } from 'react'
import { LightTooltip } from './LightTooltip'
import { useProjectStateItem } from './useProjectStateItem'
import { useRequestedProjectState } from './useRequestedProjectState'

export const RequestState = () => {
  const {
    getStateTranslationKey,
    changeStatus,
    SavingComponent,
    getBaseClassName,
  } = useProjectStateItem(ProjectStatus.REQUESTED)

  const { canChangeToRequestState, Errors, errorStyle, errorCount } =
    useRequestedProjectState()

  const handleClick = () => {
    if (canChangeToRequestState) {
      changeStatus(ProjectStateAsString.REQUESTED)
    }
  }

  const styles: CSSProperties = {
    ...(errorStyle || {}),
    pointerEvents: 'inherit',
  }

  return (
    <LightTooltip title={errorCount > 0 ? <Errors /> : ''}>
      <li style={styles} className={getBaseClassName} onClick={handleClick}>
        <LocalizedTypography
          translationKey={getStateTranslationKey()}
          variant="body2"
        />
        <ErrorCountBadge errorCount={errorCount} />

        <SavingComponent />
      </li>
    </LightTooltip>
  )
}
